module.exports = new __parcel__URL__("exercise7.07d968ec.png").toString();